(() => {
  if (window.__fpHomeCleanV10Loaded) return;
  window.__fpHomeCleanV10Loaded = true;

  const isHome = () => document.body && document.body.classList.contains('template-index');
  const railItems = (rail) => rail._fpItems || (rail._fpItems = Array.from(rail.querySelectorAll(':scope > [data-fp-rail-item]')));
  const railDots = (rail) => {
    if (rail._fpDots) return rail._fpDots;
    const section = rail.closest('.fp-home-section');
    return (rail._fpDots = section ? Array.from(section.querySelectorAll('[data-fp-dots] .fp-home-dot')) : []);
  };

  function measure(rail) {
    const cards = railItems(rail);
    const dots = railDots(rail);
    if (!cards.length) return null;

    const railRect = rail.getBoundingClientRect();
    const rtl = getComputedStyle(rail).direction === 'rtl';
    const startingEdge = rtl ? railRect.right : railRect.left;
    let active = 0;
    let min = Infinity;

    for (let i = 0; i < cards.length; i += 1) {
      const rect = cards[i].getBoundingClientRect();
      const distance = Math.abs((rtl ? rect.right : rect.left) - startingEdge);
      if (distance < min) {
        min = distance;
        active = i;
      }
    }
    return { dots, active, total: cards.length, rail, cards };
  }

  function apply(state) {
    if (!state) return;
    state.dots.forEach((dot, index) => {
      const on = index === state.active;
      dot.classList.toggle('is-active', on);
      if (on) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    const section = state.rail.closest('.fp-home-section');
    if (!section) return;
    const position = section.querySelector('[data-fp-position]');
    if (position) position.textContent = (state.active + 1) + ' / ' + state.total;
    const rtl = getComputedStyle(state.rail).direction === 'rtl';
    const railRect = state.rail.getBoundingClientRect();
    const firstRect = state.cards[0].getBoundingClientRect();
    const lastRect = state.cards[state.total - 1].getBoundingClientRect();
    const atStart = rtl ? firstRect.right <= railRect.right + 3 : firstRect.left >= railRect.left - 3;
    const atEnd = rtl ? lastRect.left >= railRect.left - 3 : lastRect.right <= railRect.right + 3;
    section.querySelectorAll('[data-fp-arrow]').forEach((arrow) => {
      arrow.disabled = arrow.dataset.fpArrow === '-1' ? atStart : atEnd;
    });
  }

  function update(rail) {
    apply(measure(rail));
  }

  function refresh(root = document) {
    if (!isHome()) return;
    const rails = Array.from(root.querySelectorAll('[data-fp-rail]'));
    const states = rails.map(measure);
    states.forEach(apply);
  }

  function goTo(rail, index) {
    const card = railItems(rail)[index];
    if (!card) return;
    const railRect = rail.getBoundingClientRect();
    const cardRect = card.getBoundingClientRect();
    const rtl = getComputedStyle(rail).direction === 'rtl';
    const distance = rtl ? cardRect.right - railRect.right : cardRect.left - railRect.left;
    rail.scrollBy({ left: distance, behavior: 'smooth' });
  }

  function setup(rail) {
    if (rail.dataset.fpV10Ready === '1') return;
    rail.dataset.fpV10Ready = '1';

    railItems(rail);
    railDots(rail).forEach((dot, index) => dot.addEventListener('click', () => goTo(rail, index)));
    const section = rail.closest('.fp-home-section');
    if (section) {
      section.querySelectorAll('[data-fp-arrow]').forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const state = measure(rail);
          if (!state) return;
          const next = Math.max(0, Math.min(state.total - 1, state.active + Number(arrow.dataset.fpArrow)));
          if (next !== state.active) goTo(rail, next);
        });
      });
    }

    rail.addEventListener('scroll', () => {
      if (rail._fpV10Tick) return;
      rail._fpV10Tick = true;
      requestAnimationFrame(() => {
        rail._fpV10Tick = false;
        update(rail);
      });
    }, { passive: true });
  }

  function init(root = document) {
    if (!isHome()) return;
    root.querySelectorAll('[data-fp-rail]').forEach(setup);
    requestAnimationFrame(() => refresh(root));
  }

  function start() {
    if (!isHome()) return;
    init(document);
    let resizeFrame = 0;
    window.addEventListener('resize', () => {
      if (resizeFrame) return;
      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = 0;
        refresh(document);
      });
    }, { passive: true });

    document.addEventListener('shopify:section:load', (event) => init(event.target || document));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();